export default __webpack_public_path__ + "static/media/Account_profile_user_avatar.1da7d43d.svg";